// extracted by mini-css-extract-plugin
export default {"root":"MemberManagement_root__NG-BI"};